

const orders_transformer = async function(response) {
  const orders = response?.data?.message ?? []
  return orders.reduce((acc, si) => {
    acc[si.offline_pos_name] = acc[si.offline_pos_name] ?? {
      name: si.offline_pos_name ?? 'UNKNOWN',
      posting_time: si.posting_time,
      items: []
    }
    acc[si.offline_pos_name].items.push({
      item_name: si.item_name,
      item_code: si.item_code,
      item_group: si.item_group,
      qty: si.qty,
      time: si.modified,
      amount: si.amount,
      notes: 'Well done medium rare'
    })
    return acc
  }, {})
}

export default orders_transformer
